module.exports = __webpack_public_path__ + "static/media/pin_specialistici_convenzionati_highlighted.5ba14ad2.png";